import React, { useReducer, createContext, useContext } from "react";
import reducerBusiness, { initialize } from "../Reducer/reducerBusiness";

export const StateContext = createContext(null);

export const StateBusinessProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducerBusiness, initialize);

  return (
    <StateContext.Provider value={{ state, dispatch }}>
      {children}
    </StateContext.Provider>
  );
};

export const useStateValue = () => {
  const context = React.useContext(StateContext);

  if (!context) {
    throw new Error(
      "useStateValue must be used inside a StateBusinessProvider"
    );
  }

  return context;
};

